import React from 'react';
import { ZoomIn, ZoomOut, Hand, Pencil, Code, Trash2 } from 'lucide-react'; // Added Trash2 icon

function CanvasToolbar({
  activeTool,
  onZoomIn,
  onZoomOut,
  onSetTool,
  onChangeView, // Added
  viewingCode, // Added
  onAnnotationCancel, // Added
  onClearAnnotations, // Added for clearing drawings
  hasAnnotations, // Added to check if there are annotations to clear
}) {
  const buttonClass = (toolName) =>
    `p-2 rounded hover:bg-gray-200 ${
      activeTool === toolName ? 'bg-blue-100 text-blue-700' : 'bg-white text-gray-600'
    }`;

  return (
    <div className="absolute bottom-4 right-4 z-20 flex flex-col gap-1 p-1 bg-white rounded-md shadow-md border border-gray-200">
      {/* View toggle button */}
      <button 
        onClick={onChangeView} 
        title={viewingCode ? "Switch to Design View" : "Switch to Code View"} 
        className="p-2 rounded hover:bg-gray-200 bg-white text-gray-600"
      >
        <Code size={18} />
      </button>
      <div className="h-px bg-gray-200 my-1"></div> {/* Separator */}
      
      {!viewingCode && (
        <>
          <button onClick={onZoomIn} title="Zoom In" className="p-2 rounded hover:bg-gray-200 bg-white text-gray-600">
            <ZoomIn size={18} />
          </button>
          <button onClick={onZoomOut} title="Zoom Out" className="p-2 rounded hover:bg-gray-200 bg-white text-gray-600">
            <ZoomOut size={18} />
          </button>
          <div className="h-px bg-gray-200 my-1"></div> {/* Separator */}
          <button
            onClick={() => onSetTool('pan')}
            title="Pan Tool (P)"
            className={buttonClass('pan')}
          >
            <Hand size={18} />
          </button>
          <button
            onClick={() => onSetTool('draw')}
            title="Draw Tool (D)"
            className={buttonClass('draw')}
          >
            <Pencil size={18} />
          </button>
          <button
            onClick={() => onSetTool('select')}
            title="Select Tool (S)"
            className={buttonClass('select')}
          >
            {/* Use a suitable icon for select, e.g., mouse pointer or annotation icon */}
            {/* Placeholder icon for now */}
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path><path d="m13 13 6 6"></path></svg>
          </button>
          
          {/* Show clear button when there are annotations or draw tool is active */}
          {(hasAnnotations || activeTool === 'draw') && (
            <>
              <div className="h-px bg-gray-200 my-1"></div> {/* Separator */}
              <button
                onClick={onClearAnnotations}
                title="Clear Drawings (Esc)"
                className="p-2 rounded hover:bg-gray-200 bg-white text-red-500"
              >
                <Trash2 size={18} />
              </button>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default CanvasToolbar; 